<template>
  <div class="not-found-page">

    <div class="row pb-5" style="margin-top:110px">
      <div class="col-12 col-lg-10 mx-auto">
        <div class="bg-white shadow-sm">

          <div class="row">
            <div class="col-10 mx-auto my-5">

              <h1>Página não encontrada :(</h1>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>

<style lang="scss" scoped>
</style>